import { render, staticRenderFns } from "./ChoirMinistryService.vue?vue&type=template&id=0870009b&"
import script from "./ChoirMinistryService.vue?vue&type=script&lang=js&"
export * from "./ChoirMinistryService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports